export default __webpack_public_path__ + "static/media/microcentrifuge_topview_example.b985bd4a.svg";